// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-e7aa128c] .el-drawer__body {\n  overflow: auto;\n  padding: 30px;\n}", ""]);
// Exports
module.exports = exports;
